import * as yup from "yup";
import addYears from 'date-fns/addYears';
import startOfToday from 'date-fns/startOfToday';

export const schemaStepApartment = yup.object().shape({
    apartmentId: yup
        .number()
        .typeError('Selezionare un appartamento')
        // eslint-disable-next-line
        .min(1, 'Deve essere maggiore o uguale a ${min}')
        .required('Campo obbligatorio'),
});

export const schemaStepOffer = yup.object().shape({
    startDate: yup
        .date()
        .typeError('Deve essere una data valida gg/mm/aaaa')
        .max(yup.ref('endDate'), 'Deve essere minore o uguale alla data di fine')
        .required('Campo obbligatorio'),
    endDate: yup
        .date()
        .typeError('Deve essere una data valida gg/mm/aaaa')
        .min(startOfToday(), 'Deve essere maggiore o uguale alla data di oggi')
        .max(addYears(startOfToday(),2), 'Deve essere più piccolo di 2 anni da oggi')
        .required('Campo obbligatorio'),
    price: yup
        .number()
        .typeError('Deve essere un numero')
        // eslint-disable-next-line
        .min(1, 'Deve essere maggiore o uguale a ${min}')
        .test("maxTwoDecimals", "Non è un prezzo valido", (number) => /^\d+(.(\d{1,2})?)?$/.test(String(number)))
        .required('Campo obbligatorio'),
    minPeople: yup
        .number()
        .typeError('Deve essere un numero')
        // eslint-disable-next-line
        .min(1, 'Deve essere maggiore o uguale a ${min}')
        .required('Campo obbligatorio'),
    minNight: yup
        .number()
        .typeError('Deve essere un numero')
        // eslint-disable-next-line
        .min(1, 'Deve essere maggiore o uguale a ${min}')
        .required('Campo obbligatorio'),
    petsAllowed: yup
        .boolean()
        .required('Campo obbligatorio'),
});

export const schemaStepDescription = yup.object().shape({
    titleIt: yup
        .string()
        .max(50, 'Deve avere al massimo 50 caratteri')
        .typeError('Deve essere in formato testuale')
        .required('Campo obbligatorio'),
    titleEn: yup
        .string()
        .max(50, 'Deve avere al massimo 50 caratteri')
        .typeError('Deve essere in formato testuale')
        .required('Campo obbligatorio'),
    descriptionIt: yup
        .string()
        .typeError('Deve essere in formato testuale')
        .required('Campo obbligatorio'),
    descriptionEn: yup
        .string()
        .typeError('Deve essere in formato testuale')
        .required('Campo obbligatorio'),
});

export const schemaOffer = [schemaStepApartment, schemaStepOffer, schemaStepDescription].reduce((acc,x) => acc.concat(x));